<template>
  <div class="content building-manage">
    <h3 ref="pageHeader" class="pageHeader">楼宇管理</h3>

    <div class="toolbar">
      <el-button type="primary" icon="el-icon-plus" @click="handleAddCampus">
        新增校区
      </el-button>
      <el-button icon="el-icon-refresh" @click="getList">刷新</el-button>
    </div>

    <div v-loading="loading" class="tree-panel">
      <el-tree
        ref="buildingTree"
        :data="treeData"
        :props="treeProps"
        node-key="id"
        default-expand-all
        :expand-on-click-node="false"
        empty-text="暂无楼宇数据"
      >
        <span slot-scope="{ node, data }" class="custom-tree-node">
          <span class="node-name" :title="node.label">{{ node.label }}</span>
          <span class="node-actions">
            <el-tooltip content="新增下级" placement="top">
              <el-button
                type="primary"
                size="mini"
                icon="el-icon-plus"
                circle
                @click.stop="handleAddChild(data)"
              ></el-button>
            </el-tooltip>
            <!-- <el-tooltip content="预览" placement="top">
              <el-button
                type="info"
                size="mini"
                icon="el-icon-view"
                circle
                @click.stop="handlePreview(data, node)"
              ></el-button>
            </el-tooltip> -->
            <el-tooltip content="编辑" placement="top">
              <el-button
                type="warning"
                size="mini"
                icon="el-icon-edit"
                circle
                @click.stop="handleEdit(data)"
              ></el-button>
            </el-tooltip>
            <el-tooltip content="删除" placement="top">
              <el-button
                type="danger"
                size="mini"
                icon="el-icon-delete"
                circle
                @click.stop="handleDelete(data)"
              ></el-button>
            </el-tooltip>
          </span>
        </span>
      </el-tree>
    </div>

    <el-dialog
      :title="dialogTitle"
      :visible.sync="dialogVisible"
      :close-on-click-modal="false"
      width="460px"
      @closed="resetForm"
    >
      <el-form ref="buildingForm" :model="ruleForm" :rules="rules" label-width="90px">
        <!-- <el-form-item v-if="dialogType === 'add'" label="上级节点">
          <el-input v-model="parentName" disabled></el-input>
        </el-form-item> -->
        <el-form-item label="名称" prop="name">
          <el-input
            v-model.trim="ruleForm.name"
            maxlength="50"
            show-word-limit
            placeholder="请输入楼宇或校区名称"
            @keyup.enter.native="submitForm"
          ></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取消</el-button>
        <el-button type="primary" :loading="submitting" @click="submitForm">确定</el-button>
      </span>
    </el-dialog>

    <el-dialog
      title="楼宇预览"
      :visible.sync="previewVisible"
      :close-on-click-modal="false"
      width="460px"
    >
      <div class="preview-list">
        <div class="preview-item">
          <span class="preview-label">名称</span>
          <span>{{ previewNode.name || '-' }}</span>
        </div>
        <div class="preview-item">
          <span class="preview-label">节点 ID</span>
          <span>{{ previewNode.id || '-' }}</span>
        </div>
        <div class="preview-item">
          <span class="preview-label">上级节点 ID</span>
          <span>{{ previewNode.parent_id || '1' }}</span>
        </div>
        <div class="preview-item">
          <span class="preview-label">下级数量</span>
          <span>{{ previewNode.childrenCount }}</span>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
export default {
  name: 'buildingManage',
  data() {
    return {
      loading: false,
      submitting: false,
      treeData: [],
      treeProps: {
        children: 'children',
        label: 'name',
      },
      dialogVisible: false,
      dialogTitle: '新增校区',
      dialogType: 'add',
      parentName: '根节点',
      ruleForm: {
        name: '',
        parent_id: '1',
        id: '',
      },
      rules: {
        name: [{ required: true, message: '请输入名称', trigger: 'blur' }],
      },
      previewVisible: false,
      previewNode: {
        name: '',
        id: '',
        parent_id: '1',
        childrenCount: 0,
      },
    };
  },
  mounted() {
    this.getList();
  },
  methods: {
    /**
     * 获取楼宇树列表，并统一为 el-tree 使用的 children 字段。
     */
    async getList() {
      this.loading = true;
      try {
        const res = await this.$api.instance.interfaceServer(
          'api/training/room/building/list',
          'get',
          {}
        );
        if (res && res.code === 0) {
          this.treeData = this.normalizeTree(this.extractList(res.data));
        } else if (res) {
          this.$message.error(res.msg || '楼宇列表加载失败');
        }
      } catch (error) {
        this.$message.error(error.message || '楼宇列表加载失败');
      } finally {
        this.loading = false;
      }
    },

    extractList(data) {
      if (Array.isArray(data)) {
        return data;
      }
      if (!data || typeof data !== 'object') {
        return [];
      }
      if (Array.isArray(data.data)) {
        return data.data;
      }
      if (Array.isArray(data.list)) {
        return data.list;
      }
      if (Array.isArray(data.records)) {
        return data.records;
      }
      if (data.id || data.name) {
        return [data];
      }
      return [];
    },

    normalizeTree(list) {
      return list.map((item) => {
        const children = Array.isArray(item.children)
          ? item.children
          : Array.isArray(item.sub)
            ? item.sub
            : [];
        return {
          ...item,
          id: item.id === undefined || item.id === null ? '' : String(item.id),
          name: item.name || item.label || '',
          children: this.normalizeTree(children),
        };
      });
    },

    handleAddCampus() {
      this.openAddDialog('1', '根节点', '新增校区');
    },

    handleAddChild(data) {
      this.openAddDialog(data.id, data.name, '新增下级');
    },

    openAddDialog(parentId, parentName, title) {
      this.dialogType = 'add';
      this.dialogTitle = title;
      this.parentName = parentName;
      this.ruleForm = {
        name: '',
        parent_id: String(parentId || '1'),
        id: '',
      };
      this.dialogVisible = true;
    },

    handleEdit(data) {
      this.dialogType = 'edit';
      this.dialogTitle = '编辑楼宇';
      this.ruleForm = {
        name: data.name || '',
        parent_id: '',
        id: data.id,
      };
      this.dialogVisible = true;
    },

    handlePreview(data, node) {
      this.previewNode = {
        name: data.name || '',
        id: data.id || '',
        parent_id: data.parent_id || this.getParentId(node),
        childrenCount: Array.isArray(data.children) ? data.children.length : 0,
      };
      this.previewVisible = true;
    },

    getParentId(node) {
      if (node && node.parent && node.parent.data && node.parent.data.id) {
        return node.parent.data.id;
      }
      return '1';
    },

    submitForm() {
      this.$refs.buildingForm.validate(async (valid) => {
        if (!valid || this.submitting) {
          return;
        }
        this.submitting = true;
        try {
          const params = this.dialogType === 'add'
            ? { name: this.ruleForm.name, parent_id: this.ruleForm.parent_id }
            : { name: this.ruleForm.name, id: this.ruleForm.id };
          const url = this.dialogType === 'add'
            ? 'api/training/room/building/add'
            : 'api/training/room/building/edit';
          const res = await this.$api.instance.interfaceServer(url, 'post', params);
          if (res && res.code === 0) {
            this.$message.success(this.dialogType === 'add' ? '新增成功' : '编辑成功');
            this.dialogVisible = false;
            await this.getList();
          } else if (res) {
            this.$message.error(res.msg || '操作失败');
          }
        } catch (error) {
          this.$message.error(error.message || '操作失败');
        } finally {
          this.submitting = false;
        }
      });
    },

    async handleDelete(data) {
      try {
        await this.$confirm(`确认删除“${data.name}”吗？`, '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning',
        });
      } catch (error) {
        return;
      }

      try {
        const res = await this.$api.instance.interfaceServer(
          'api/training/room/building/delete',
          'delete',
          { id: data.id }
        );
        if (res && res.code === 0) {
          this.$message.success('删除成功');
          await this.getList();
        } else if (res) {
          this.$message.error(res.msg || '删除失败');
        }
      } catch (error) {
        this.$message.error(error.message || '删除失败');
      }
    },

    resetForm() {
      if (this.$refs.buildingForm) {
        this.$refs.buildingForm.resetFields();
      }
    },
  },
};
</script>

<style lang="less" scoped>
.pageHeader:before {
  width: 90px;
}

.toolbar {
  margin-bottom: 16px;
}

.tree-panel {
  min-height: 280px;
  padding: 20px;
  background: #fff;
}

.custom-tree-node {
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  min-height: 34px;
  padding-right: 8px;
  border-bottom: 1px dashed #dcdfe6;
}

.node-name {
  flex: 1;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.node-actions {
  display: flex;
  flex: 0 0 auto;
  gap: 6px;
  margin-left: 16px;
}

.node-actions /deep/ .el-button--mini {
  padding: 5px;
}

.preview-list {
  padding: 0 8px;
}

.preview-item {
  display: flex;
  min-height: 38px;
  align-items: center;
  border-bottom: 1px solid #ebeef5;
  color: #606266;
}

.preview-label {
  display: inline-block;
  width: 110px;
  color: #303133;
}

/deep/ .el-tree-node__content {
  height: auto;
  min-height: 40px;
}
</style>
